import { Props } from "~/components/category/[id]/quest/type";

type CategoryId = number;
type CollaboratedUserId = number;
type Quest = {
  userId: number;
  categoryId: CategoryId;
};
type CollaboratedQuestMap = Record<CategoryId, CollaboratedUserId[]>;
const collaboratedQuestMap: CollaboratedQuestMap = {
  160: [177],
  79: [869],
  188: [869],
  190: [1310],
  191: [869],
  192: [869],
};

export function isCollaboratedQuest(quest: Quest) {
  return (collaboratedQuestMap[quest.categoryId] ?? []).includes(quest.userId);
}

export function extractCollaboratedQuests({
  quests,
  categoryId,
}: {
  quests: Props["category"]["quests"];
  categoryId: number;
}): Props["category"]["quests"] {
  return quests.filter((quest) =>
    isCollaboratedQuest({ ...quest, categoryId, userId: quest.user.id })
  );
}
